import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { UserSaleOffer } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import styles from './SaleOfferMovileViewColumn.module.scss'
import { getFormatedPrice, getProjectUnit, getTransformedDate } from 'src/core/helpers'
import { CustomText, FormLabels, SaleOfferStatusColumn, SaleOfferActionsColumn } from 'src/components'

const SaleOfferMovileViewColumn: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  // Project
  const projectLabel = offer.vintage_year ? `${offer.project_name} (${offer.vintage_year})` : offer.project_name

  // Amount Label
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === offer.currency)?.code
  const amountLabel = `${offer.amount} ${getProjectUnit(offer.project_kind)}`
  const priceLabel = `${getFormatedPrice(offer.price_per_unit, currencyCode)}`
  const amountFullLabel = `${amountLabel} x ${priceLabel}`

  // Total
  const totalLabel = `${getFormatedPrice(offer.total, currencyCode)}`

  // Expiration Date
  const dateLabel = offer.expiration_date ? getTransformedDate(offer.expiration_date) : null

  return <>
    <FormLabels
      title={projectLabel}
      subtitle={amountFullLabel}
      thirdLabel={totalLabel}
    />
    {dateLabel && <CustomText label={dateLabel} type='secondary' className={styles.date} />}
    {(offer.show_discount && offer.discount) && (
      <CustomText
        label={`${offer.discount}%`}
        type='secondary'
        className={styles.discount}
        mark
      />
    )}
    <div className={styles.content}>
      <SaleOfferStatusColumn offer={offer} />
      <SaleOfferActionsColumn offer={offer} />
    </div>
  </>
}

export default SaleOfferMovileViewColumn
